var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"col-lg-5 col-xl-4  d-none d-sm-none d-md-block"},[(!_vm.logeados)?_c('side-bar-login'):_vm._e(),(_vm.logeados)?_c('user-menu-side'):_vm._e(),_c('side-bar-expos'),_c('hr'),_c('side-bar-patrocinador')],1)}
var staticRenderFns = []

export { render, staticRenderFns }